/** Matches Sawtimber/Pulpwood tickFormatter so measured width matches rendered labels. */
export function formatCompanyYAxisTick(value) {
  const s = String(value);
  if (s.includes('Billerud')) return 'Billerud';
  return s.replace(/\s/g, '\u00A0');
}

const TICK_FONT = '12px "Bw Nista Grotesk", sans-serif';
/** Padding for tick box / anti-aliasing; aligns with chart `text-xs` axis labels. */
const TICK_EXTRA = 12;
const MIN_WIDTH = 72;
const MAX_WIDTH = 320;

/**
 * Computes Recharts YAxis width for vertical bar charts so category labels are not clipped.
 * Uses canvas text metrics (same font stack as chart axis styling).
 */
export function measureMaxYAxisLabelWidth(labels, formatTick = formatCompanyYAxisTick) {
  if (!labels?.length) return MIN_WIDTH;
  if (typeof document === 'undefined') return MIN_WIDTH;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return MIN_WIDTH;

  ctx.font = TICK_FONT;
  let max = 0;
  for (const label of labels) {
    const w = ctx.measureText(formatTick(label)).width;
    if (w > max) max = w;
  }

  return Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, Math.ceil(max) + TICK_EXTRA));
}
